import { AutocompleteField, SelectField } from '@scale/shared/types/params/textcollection';
import {
  AutocompleteFieldAnnotation,
  SelectFieldAnnotation,
} from '@scale/shared/types/response/textcollection';
import FieldHeader from 'react-scale/components/scalers/tasks/textcollection/SimpleTextCollection/FieldHeader';
import { Autocomplete } from '@scale/scaleui';

interface DropdownFieldSectionProps {
  field: AutocompleteField | SelectField;
  annotation: AutocompleteFieldAnnotation | SelectFieldAnnotation;
  setAnnotation: (annotation: AutocompleteFieldAnnotation | SelectFieldAnnotation) => void;
  disabled?: boolean;
}

export default function DropdownFieldSection({
  field,
  annotation,
  setAnnotation,
  disabled,
}: DropdownFieldSectionProps) {
  return (
    <div>
      <FieldHeader title={field.title} description={field.description} hint={field.hint} />
      <Autocomplete
        value={annotation.response?.[0] || ''}
        options={(field as AutocompleteField).options ?? (field as SelectField).choices ?? []}
        setSelectedOption={selectedOption => {
          setAnnotation({
            ...annotation,
            response: [selectedOption],
          });
        }}
        disabled={disabled}
        inputProps={{
          className: 'bg-neutral-0',
        }}
        canCreateOption={false}
      />
    </div>
  );
}
